import { Markdown } from '@components/markdown/Markdown';

import styles from './info-page-detail.module.scss';

interface InfoPageDetailProps {
	title: string;
	text: string;
}

export const InfoPageDetail = ({ title, text }: InfoPageDetailProps) => {
	return (
		<article className={styles['info-page-detail']}>
			<h1 className={styles['info-page-detail__heading']}>{title}</h1>
			<Markdown className={styles['info-page-detail__text']} text={text} />
		</article>
	);
};
